const getParamValue = (paramName: string): string => {
  if (!paramName) return paramName;

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(paramName) || "";
};

export default getParamValue;
